export default "__VITE_ASSET__31a88f11__"